import * as React from 'react';
import * as mui from '@mui/material';
import * as icons from '@mui/icons-material';

import TextField from 'components/General/TextField';
import CharacterDialogButton from 'components/General/CharacterDialogButton';
import StoryOptionButton from 'components/General/StoryOptionButton';

import BOOKS from 'constants/BOOKS';
import { usePreviewPageContext } from 'context/PreviewPageContext';

export default function Step1() {
	const {
		selectedStory,
		setSelectedStory,
		name1,
		name2,
		name3,
		setName1,
		city,
		setCity,
		character1,
		character2,
		character3,
		setCharacter1,
		setCharacter2,
		setCharacter3,
		handleContinue,
	} = usePreviewPageContext();

	const setCharacter1WithEffects = (character: string) => {
		setCharacter1(character);
		setCharacter2('');
		setCharacter3('');
	};

	return (
		<>
			<mui.Typography color='#fff' sx={{ typography: { xs: 'h6', sm: 'h5' }, mb: 3 }}>
				1. Scegli la storia da cui iniziare
			</mui.Typography>

			<mui.Grid container alignItems='flex-start' justifyContent='center' spacing={2} sx={{ mb: 4 }}>
				{Object.keys(BOOKS).map(story => (
					<mui.Grid item xs={6} sm={6} md={6} lg={3}>
						<mui.Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' } }}>
							<StoryOptionButton
								story={story}
								name1={name1}
								name2={name2}
								name3={name3}
								character1={character1}
								character2={character2}
								character3={character3}
								selectedStory={selectedStory}
								setSelectedStory={setSelectedStory}
							/>
						</mui.Box>
					</mui.Grid>
				))}
			</mui.Grid>

			<mui.Typography color='#fff' sx={{ typography: { xs: 'h6', sm: 'h5' }, mb: 3 }}>
				2. Indica la vostra città di partenza
			</mui.Typography>

			<TextField
				value={city}
				setValue={setCity}
				placeholder='Nome città'
				errorMessage='Il nome della città inserita è troppo lungo'
				startIcon={
					<img
						src={
							city.toLowerCase() === 'milano' ? '/wp-content/uploads/2021/11/citta-milano.jpg' : '/wp-content/uploads/2021/11/citta.jpg'
						}
						loading='lazy'
						alt='first protagonist'
						width='35px'
						height='35px'
					/>
				}
			/>

			<mui.Typography color='#fff' sx={{ typography: { xs: 'h6', sm: 'h5' }, mt: 4, mb: 3 }}>
				3. Scrivi il nome del primo protagonista
			</mui.Typography>

			<TextField
				value={name1}
				setValue={setName1}
				placeholder='Nome primo protagonista'
				startIcon={
					<img
						src={
							character1
								? `https://storage.googleapis.com/faboola_wordpress_static/img/characters/${character1.toUpperCase()}.png`
								: '/wp-content/uploads/2021/11/testavuota.jpg'
						}
						loading='lazy'
						alt='first protagonist'
						width='35px'
						height='35px'
					/>
				}
				errorMessage={"Inserisci un nome con meno di 20 caratteri e scegli l'aspetto"}
				StackProps={{ sx: { mb: 4 } }}
			/>

			<mui.Typography color='#fff' sx={{ typography: { xs: 'h6', sm: 'h5' }, mb: 3 }}>
				4. {character1 === '' ? 'Scegli il suo aspetto' : 'Cambia il suo aspetto'}
			</mui.Typography>

			<mui.Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={3} sx={{ mb: 4 }}>
				<CharacterDialogButton index={1} isMale={false} selectedCharacter={character1} setSelectedCharacter={setCharacter1WithEffects} />
				<CharacterDialogButton index={1} isMale={true} selectedCharacter={character1} setSelectedCharacter={setCharacter1WithEffects} />
			</mui.Stack>

			<mui.Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
				<mui.Button variant='contained' size='large' onClick={handleContinue} endIcon={<icons.ArrowForwardOutlined />} sx={{ ml: 1 }}>
					Continua
				</mui.Button>
			</mui.Box>
		</>
	);
}
